import "./ServicesHero.css";
import HeroService from "../assets/HeroService.png";

const ServicesHero = () => {
  return (
    <section className="services-hero">

      {/* Background */}
      <div className="services-hero-bg">
        <img src={HeroService} alt="" />
      </div>

      {/* Dark Overlay */}
      <div className="services-hero-overlay"></div>

      {/* Content */}
      <div className="services-hero-content">

        <span className="services-pill">
          WEB · MOBILE · SOFTWARE · GAMES
        </span>

        <h1>
          Building Digital Experiences
          <br />
          <span>That Power the Future</span>
        </h1>

        <p>
          Shirdhankar Technologies delivers cutting-edge web, mobile,
          software, and game development solutions to help businesses
          innovate and grow.
        </p>

        <div className="services-buttons">

          <a href="#services" className="primary">
            Explore Services
          </a>

          <a href="#contact" className="secondary">
            Contact Us
          </a>

        </div>

      </div>

    </section>
  );
};

export default ServicesHero;